import {
    MASK,
} from './constants';

export function shouldChange(value: string): boolean {
    const [day, month, year] = value.split('.');

    if (day) {
        if (day[0]) {
            if (!/[0-3]/.test(day[0])) {
                return false;
            }
        }
        if (day[1]) {
            if (day[0] === '3') {
                if (!/[0-1]/.test(day[1])) {
                    return false;
                }
            }
        }
    }
    if (month) {
        if (month[0]) {
            if (!/[0-1]/.test(month[0])) {
                return false;
            }
        }
        if (month[1]) {
            if (month[0] === '1') {
                if (!/[0-2]/.test(month[1])) {
                    return false;
                }
            }
        }
    }
    if (year) {
        if (year[0]) {
            if (!/[1-2]/.test(year[0])) {
                return false;
            }
        }
        if (year[1]) {
            if (year[0] === '1') {
                if (!/9/.test(year[1])) {
                    return false;
                }
            }
            if (year[0] === '2') {
                if (!/0/.test(year[1])) {
                    return false;
                }
            }
        }
    }

    return true;
}

export function formatValue(value: string): string | null {
    if (value.length !== MASK.length) {
        return null;
    }
    if (isNaN(new Date(value).getTime())) {
        return null;
    }

    return value;
}
